export default __webpack_public_path__ + "static/media/edit.2dd25737.svg";